module.exports = __webpack_public_path__ + "img/finished-f2c432097fec454744c7d02569f25d62.svg";